<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="center"
  >
    <template slot="header">
      <h5 class="modal-title">{{ modalTitle }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Justificación</label>
            <app-input
              type="textarea"
              v-model="inputs.observation"
              :required="true"
              placeholder="Justifique el porque elimina el alcance"
            />
          </div>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Aceptar
      </button>
      <button
        type="button"
        class="btn btn-secondary ml-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cancelar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    selectedUrl: String,
    id: Number,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
    };
  },
  created() {},
  methods: {
    submit() {
      if (!this.inputs.observation) {
        this.$toastr.e(this.$t("deleted_success"));
        return;
      }

      this.disabledSubmit = true;
      this.preloader = true;

      let url = `request/${this.id}/deactivate`;
      const data = {
        ...this.inputs,
      };

      this.axiosPatch({ url, data })
        .then((response) => {
          if (response.status == 200) {
            this.$toastr.s(this.$t("deleted_success"));
            this.$hub.$emit("reload-" + this.tableId);
            this.closeModal();
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toastr.e("Error al intentar eliminar el alcance");
        })
        .finally(() => {
          this.preloader = false;
          this.disabledSubmit = false;
        });

      // this.save(this.inputs);
    },
  },
};
</script>
